import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('add_a_comment_about_the_changes_made'),
    description1: defineMessage('youre_updating_the_current_group_of_values'),
    description2: defineMessage('to_inform_others_about__a_comment_here_optional'),
    buttonText: defineMessage('confirm'),
    addCommentPlaceholder: defineMessage('add_a_comment'),
};
